module.exports = __webpack_public_path__ + "static/media/DK4055_08.727773f4.jpg";